import UseAxios from '../../../Api/http/http';
import {
  departmentData,
  verticalData,
  designationData,
  performnacePeriodData,
  getLostOrDroppedReasonData,
  getGeographyListData,
} from '../../../Api/request/master';


const fetchAndMapList = async (apiRequest, mapFunction) => {
  try {
    const response = await UseAxios(apiRequest);
    return response.data ? mapFunction(response.data) : [];
  } catch (error) {
    return [];
  }
};

export const fetchVertivalList = async () => {
  return await fetchAndMapList(
    verticalData(),
    (data) => data.verticalDetails.map((vertical) => ({
      id: vertical.id,
      name: vertical.verticalName,
    })),
  );
};


export const fetchDepartmentList = async () => {
  return await fetchAndMapList(
    departmentData(),
    (data) => data.departmentDetails.map((dept) => ({
      id: dept.id,
      name: dept.deptName,
    })),
  );
};

export const fetchDesignationList = async () => {
  return await fetchAndMapList(
    designationData(),
    (data) => data.designationDetails.map((designation) => ({
      id: designation.id,
      name: designation.designationName,
    })),
  );
};


export const fetchPerformancePeriodList = async () => {
  try {
    const response = await UseAxios(performnacePeriodData());
    const result = response.data.performancePeriodDetails.map((perforamance) => ({
      id: perforamance.id,
      name: perforamance.cycleName,
    }));
    return result;
  } catch (error) {
    return [];
  }
};

export const fetchLostDroppedReasonList = async (statusName) => {
  return await fetchAndMapList(
    getLostOrDroppedReasonData(statusName),
    (data) => data.lostDroppedStatusDetails.map((status) => ({
      id: status.id,
      name: status.reason,
    })),
  );
};

export const fetchGeographyList = async (filterType) => {
  return await fetchAndMapList(
    getGeographyListData(filterType),
    (data) => (data.geographyDetails || [])
      .filter(geography => geography.geographyType === filterType)
      .map((geography) => ({
        id: geography.id,
        name: geography.geographyPlace,
      })),
  );
};
